import React from 'react';

import { ILayoutProps } from '@/components/Layout';
import { CollapsableSection } from '@/components/shared/CollapsableSection';
import { getSongThemeColor } from '@/components/shared/SongThemeChip';
import {
	SmallSongCard,
	SmallSongCardList,
	SmallSongCardProps,
} from '@/components/SmallSongCard';
import {
	SmallTeamSongCard,
	SmallTeamSongCardProps,
} from '@/components/SmallTeamSongCard';
import { classNames } from '@/helpers/classNames';
import { LimitedTeamSong } from '@/providers/TeamSongsProvider';

import styles from '../Songlist360Report.module.scss';

type CreateCollapsableSectionsProps = {
	tags: {
		label: string;
		capitalisedLabel: string;
		id?: string;
	}[];
	songMetricsData: {
		id: string;
		songs: LimitedTeamSong[];
	}[];
	allSongs: LimitedTeamSong[];
	onSongClick?: SmallTeamSongCardProps['onClick'];
};

export const CreateCollapsableSections: React.FC<
	CreateCollapsableSectionsProps
> = ({ tags, songMetricsData, allSongs, onSongClick }) => {
	return (
		<>
			{[
				...tags,
				{
					label: 'unknown',
					capitalisedLabel: 'Unknown',
				},
			].map((t, i) => {
				const metricData = songMetricsData.find(
					(typeData) =>
						typeData.id === t.id || typeData.id === t.label,
				);
				if (
					!metricData ||
					(!metricData.songs.length && t.label === 'unknown')
				) {
					return null;
				}
				return (
					<CollapsableSection
						key={`collapsable-section-${t.label}`}
						className={classNames([
							styles['collapsable'],
							i === 0 && styles['first'],
							getSongThemeColor(t.label).className,
						])}
						title={t.capitalisedLabel}
						uncollapsable={!metricData?.songs.length}
						subtitle={`${metricData?.songs.length || 0} of ${
							allSongs.length
						} songs`}
					>
						<SmallSongCardList>
							{metricData?.songs.map((s) => (
								<SmallTeamSongCard
									key={`small-song-card-${t.label}-${s.name}`}
									teamSongId={s.id}
									className={styles['song']}
									onClick={(song) => {
										if (onSongClick) {
											onSongClick(song);
										}
									}}
								/>
							))}
						</SmallSongCardList>
					</CollapsableSection>
				);
			})}
		</>
	);
};
